export const GET_DATA = 'getData';